//import firebase from 'firebase'
//import 'firebase/firestore'
import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/firestore';
import 'firebase/functions';


const config = {
    apiKey: process.env.VUE_APP_firebase_apiKey,
    authDomain: process.env.VUE_APP_firebase_authDomain,
    databaseURL: process.env.VUE_APP_firebase_databaseURL,
    projectId: process.env.VUE_APP_firebase_projectId,
    storageBucket: process.env.VUE_APP_firebase_storageBucket,
    messagingSenderId: process.env.VUE_APP_firebase_messagingSenderId,
    appId: process.env.VUE_APP_firebase_appId
}
firebase.initializeApp(config)

var functions = firebase.functions();


// firebase utils
const db = firebase.firestore()
const auth = firebase.auth()
const currentUser = auth.currentUser

// date issue fix according to firebase
const settings = {
    //timestampsInSnapshots: true
}
db.settings(settings)

// firebase collections
const usersCollection = db.collection('users')
const beersCollection = db.collection('beers')
const zipcodesCollection = db.collection('zipcodes')
const ordersCollection = db.collection('orders')
const messagesCollection = db.collection('messages')
const eventsCollection = db.collection('events')
const newsfeedCollection = db.collection('newsfeed')
const distributorsCollection = db.collection('distributors')
const distributorBeersCollection = db.collection('distributorbeers')
const distributorBrewersCollection = db.collection('distributorbrewers')
const buyerReviewsCollection = db.collection('buyerreviews')
const emailsCollection = db.collection('emails')
const invoicesCollection = db.collection('invoices')
const consumerOrdersCollection = db.collection('consumerorders')
const breweryPaymentsCollection = db.collection('brewerypayments')
const brewerAdvertisementEmailsCollection = db.collection('brewerAdvertisementEmails')
const mailCollection = db.collection('mail')
const unsubscribeCollection = db.collection('unsubscribe')
const clickedTellMeMoreCollection = db.collection('clickedtellmemore')
const clickedBrewerCollection = db.collection('clickedbrewer')
const clickedAddToCartCollection = db.collection('clickedaddtocart')
const clickedSearchCollection = db.collection('clickedsearch')
const clickedStyleCollection = db.collection('clickedstyle')

const emailToEmailCollection = db.collection('emailtoemail')
const emailToEmailInfoCollection = db.collection('emailtoemailinfo') //All writes allowed. Only allow sending to info@kegseeker.com in firebase functions.
const unsubPostOffering = db.collection('unsubpostoffering')
const unsubTradingPost = db.collection('unsubscribetradingpost')
const unsubForums = db.collection('unsubscribeforums')
const forumsCollection = db.collection('forums')
const forumTitlesCollection = db.collection('forumtitles')
const displayHandlesCollection = db.collection('displayhandles')

const servicesCollection = db.collection('services')
const forSaleCollection = db.collection('forsale')

const couponsCollection = db.collection('coupons')

export {
    db,
    auth,
    currentUser,
    usersCollection,
    beersCollection,
    zipcodesCollection,
    ordersCollection,
    messagesCollection,
    eventsCollection,
    newsfeedCollection,
    distributorsCollection,
    distributorBeersCollection,
    distributorBrewersCollection,
    buyerReviewsCollection,
    emailsCollection,
    invoicesCollection,
    consumerOrdersCollection,
    breweryPaymentsCollection,
    brewerAdvertisementEmailsCollection,
    mailCollection,
    unsubscribeCollection,
    clickedTellMeMoreCollection,
    clickedBrewerCollection,
    clickedAddToCartCollection,
    clickedSearchCollection,
    clickedStyleCollection,
    emailToEmailCollection,
    emailToEmailInfoCollection,
    unsubPostOffering,
    forumsCollection,
    displayHandlesCollection,
    forumTitlesCollection,
    servicesCollection,
    forSaleCollection,
    unsubTradingPost,
    unsubForums,
    couponsCollection,
}

